export default __webpack_public_path__ + "images/MuestrasExpressBesafer 4.0-PT.png";